import React from 'react'
import classNames from 'classnames'
import styles from './style.module.css'

export default function Loader({ className, width='medium', inline=false, ...rest }) {

  const widths = {
    small: styles.small,
    medium: styles.medium,
    large: styles.large
  }

  const loaderClass = widths[width] ?? widths['medium']

  return (
    <div className={ classNames({[styles.centered]: !inline}, className)} {...rest}>
      <img src="/images/loader.svg" className={ classNames(loaderClass)} alt="Loading..." />
    </div>
  )
}